module.exports = __webpack_public_path__ + "media/Video (8).5b757db5.mp4";